import { Box, FormControl, Button, Grid, InputLabel, MenuItem, Select, TextField, Typography, FormHelperText } from '@mui/material';
import React from 'react'
import Navbar from '../components/Navbar';
import { handleKeyDown } from '../utilities';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Field, Form, Formik } from 'formik';


const Bajas = () => {
    return (
        <Grid container display={'flex'} justifyContent={'center'} >
            <Grid item xs={12} justifyContent={'center'} height={"60px"} >
                <Navbar /*handleTabClick={handleTabClick}*/ codpmpol={''} />
            </Grid>
            <Grid container display={'flex'} justifyContent={'center'}>
                <div className="tab-content">
                    <Box
                        display={"flex"}
                        justifyContent={'center'}
                        alignItems={"center"}
                        flexDirection={"column"}
                        marginBottom={5}
                    >
                        <Box width={350} marginBottom={2}>
                            <Box
                                display={"flex"}
                                justifyContent={'center'}
                                alignItems={"center"}>
                                <Typography variant='h5' margin={2}>Formulario de baja</Typography>
                            </Box>
                            <Box marginLeft={'2vw'}>
                                En empresa comprendemos que las necesidades de nuestros clientes cambian con el tiempo.
                                Por eso, si ya no querés mantener tu seguro, completá el formulario debajo y nosotros
                                nos encargamos de enviar tu solicitud a la aseguradora correspondiente.
                            </Box>
                            <Box marginTop={2} marginLeft={'2vw'}>
                                <Typography>
                                    <b>Si cambias de opinión ¡Te esperamos pronto nuevamente!</b>
                                </Typography>
                            </Box>
                        </Box>
                        <Formik
                            initialValues={{ homeType: '', name: '' }}
                            onSubmit={(values) => { console.log(values) }}
                        >
                            {({ values, handleSubmit, handleChange }) => (
                                <form onSubmit={handleSubmit}>
                                    <Form>
                                        <Field
                                            name=""
                                            render={({ field }) => (
                                                <FormControl sx={{ m: 1, width: "30ch" }}  /*error={error.homeType}*/>
                                                    <InputLabel>Seguro</InputLabel>
                                                    <Select
                                                        {...field}
                                                        label='homeType'
                                                        name='homeType'
                                                        id='homeType'
                                                        onChange={handleChange}
                                                        value={values.homeType}
                                                    >
                                                        <MenuItem value={'ARG'}>Seguro 1</MenuItem>
                                                        <MenuItem value={'BRA'}>Seguro 2</MenuItem>
                                                    </Select>
                                                    {/* {error.homeType && <FormHelperText>Tipo de vivienda requerido</FormHelperText>} */}
                                                    <FormHelperText>Seguro contratado</FormHelperText>
                                                </FormControl>
                                            )}
                                        />
                                        <Box sx={{ '& > :not(style)': { m: 1, width: '30ch' } }} noValidate autoComplete="off">
                                            <TextField
                                                // error
                                                value={values.name}
                                                label='Nombre'
                                                name='name'
                                                onChange={handleChange}
                                                // onKeyDown={handleKeyDown2}
                                                // onChange={({ target }) => {
                                                //     let updatedValue = target.value;
                                                //     updatedValue = updatedValue.slice(0, 50); // Limitar a 50 caracteres
                                                //     updatedValue = updatedValue.replace(/[^\w\sñÑáéíóúÁÉÍÓÚ]/g, '')
                                                //     // updatedValue = updatedValue.replace(/[^a-zA-Z0-9ñÑ\s]/g, '');
                                                //     handleChange('address', updatedValue);
                                                // }}
                                                // helperText={error.address ? 'Domicilio a asegurar es requerido' : error.registeredAddress ? 'Domicilio no disponible. Ingrese otro' : ''}
                                                helperText={'Nombre'}
                                            />
                                        </Box>
                                        <Box sx={{ '& > :not(style)': { m: 1, width: '30ch' } }} noValidate autoComplete="off">
                                            <TextField
                                                // error={error.address || error.registeredAddress}
                                                // value={homeData.address}
                                                label="Apellido"
                                                name='address'
                                                // onKeyDown={handleKeyDown2}
                                                // onChange={({ target }) => {
                                                //     let updatedValue = target.value;
                                                //     updatedValue = updatedValue.slice(0, 50); // Limitar a 50 caracteres
                                                //     updatedValue = updatedValue.replace(/[^\w\sñÑáéíóúÁÉÍÓÚ]/g, '')
                                                //     // updatedValue = updatedValue.replace(/[^a-zA-Z0-9ñÑ\s]/g, '');
                                                //     handleChange('address', updatedValue);
                                                // }}
                                                // helperText={error.address ? 'Domicilio a asegurar es requerido' : error.registeredAddress ? 'Domicilio no disponible. Ingrese otro' : ''}
                                                helperText={'Apellido'}
                                            />
                                        </Box>
                                        <Box sx={{ '& > :not(style)': { m: 1, width: '30ch' } }} noValidate autoComplete="off">
                                            <TextField
                                                // error={error.address || error.registeredAddress}
                                                // value={homeData.address}
                                                label="DNI"
                                                name='address'
                                                // onKeyDown={handleKeyDown2}
                                                // onChange={({ target }) => {
                                                //     let updatedValue = target.value;
                                                //     updatedValue = updatedValue.slice(0, 50); // Limitar a 50 caracteres
                                                //     updatedValue = updatedValue.replace(/[^\w\sñÑáéíóúÁÉÍÓÚ]/g, '')
                                                //     // updatedValue = updatedValue.replace(/[^a-zA-Z0-9ñÑ\s]/g, '');
                                                //     handleChange('address', updatedValue);
                                                // }}
                                                // helperText={error.address ? 'Domicilio a asegurar es requerido' : error.registeredAddress ? 'Domicilio no disponible. Ingrese otro' : ''}
                                                helperText={'Documento'}
                                            />
                                        </Box>
                                        <div onKeyDown={handleKeyDown}>
                                            <Box component="form" sx={{ '& > :not(style)': { m: 1, width: '30ch' }, }} noValidate autoComplete="off" >
                                                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                                                    <DesktopDatePicker
                                                        format="DD/MM/YYYY"
                                                        // defaultValue={titularData.birthday?.$d}
                                                        variant="outlined"
                                                        name='birthday'
                                                        label="Fecha de Nacimiento"
                                                        // ref={birthdayRef}
                                                        // value={dayjs(titularData.birthday)}
                                                        // onChange={(date) => {
                                                        //   handleChange('birthday', date);
                                                        // }}
                                                        slotProps={{
                                                            textField: {
                                                                //     error: error.birthday || error.age || error.elderly || error.seventy,
                                                                //     helperText: error.birthday ? 'La fecha de nacimiento es requerida' : error.age ? 'Debe ser mayor de edad' : error.elderly ? 'Verifique fecha de nacimiento' : error.seventy ? 'Personas mayores de 70 años no pueden adquirir este seguro' : '',
                                                                helperText: 'Fecha de nacimiento'
                                                            }
                                                        }}
                                                    />
                                                </LocalizationProvider>
                                            </Box>
                                        </div>
                                        <Box sx={{ '& > :not(style)': { m: 1, width: '30ch' } }} noValidate autoComplete="off">
                                            <TextField
                                                // error={error.address || error.registeredAddress}
                                                // value={homeData.address}
                                                label="Número de póliza"
                                                name='address'
                                                // onKeyDown={handleKeyDown2}
                                                // onChange={({ target }) => {
                                                //     let updatedValue = target.value;
                                                //     updatedValue = updatedValue.slice(0, 50); // Limitar a 50 caracteres
                                                //     updatedValue = updatedValue.replace(/[^\w\sñÑáéíóúÁÉÍÓÚ]/g, '')
                                                //     // updatedValue = updatedValue.replace(/[^a-zA-Z0-9ñÑ\s]/g, '');
                                                //     handleChange('address', updatedValue);
                                                // }}
                                                // helperText={error.address ? 'Domicilio a asegurar es requerido' : error.registeredAddress ? 'Domicilio no disponible. Ingrese otro' : ''}
                                                helperText={'Número de póliza'}
                                            />
                                        </Box>
                                        <Box sx={{ '& > :not(style)': { m: 1, width: '30ch' } }} noValidate autoComplete="off">
                                            <TextField
                                                // error={error.address || error.registeredAddress}
                                                // value={homeData.address}
                                                label="Email"
                                                name='address'
                                                // onKeyDown={handleKeyDown2}
                                                // onChange={({ target }) => {
                                                //     let updatedValue = target.value;
                                                //     updatedValue = updatedValue.slice(0, 50); // Limitar a 50 caracteres
                                                //     updatedValue = updatedValue.replace(/[^\w\sñÑáéíóúÁÉÍÓÚ]/g, '')
                                                //     // updatedValue = updatedValue.replace(/[^a-zA-Z0-9ñÑ\s]/g, '');
                                                //     handleChange('address', updatedValue);
                                                // }}
                                                // helperText={error.address ? 'Domicilio a asegurar es requerido' : error.registeredAddress ? 'Domicilio no disponible. Ingrese otro' : ''}
                                                helperText={'Email'}
                                            />
                                        </Box>
                                        <Box sx={{ '& > :not(style)': { m: 1, width: '30ch' } }} noValidate autoComplete="off">
                                            <TextField
                                                // error={error.address || error.registeredAddress}
                                                // value={homeData.address}
                                                label="Teléfono"
                                                name='address'
                                                // onKeyDown={handleKeyDown2}
                                                // onChange={({ target }) => {
                                                //     let updatedValue = target.value;
                                                //     updatedValue = updatedValue.slice(0, 50); // Limitar a 50 caracteres
                                                //     updatedValue = updatedValue.replace(/[^\w\sñÑáéíóúÁÉÍÓÚ]/g, '')
                                                //     // updatedValue = updatedValue.replace(/[^a-zA-Z0-9ñÑ\s]/g, '');
                                                //     handleChange('address', updatedValue);
                                                // }}
                                                // helperText={error.address ? 'Domicilio a asegurar es requerido' : error.registeredAddress ? 'Domicilio no disponible. Ingrese otro' : ''} 
                                                helperText={'Sin 0 y sin 15'}
                                            />
                                        </Box>
                                        <FormControl sx={{ m: 1, width: "30ch" }} /*error={error.homeType}*/>
                                            <InputLabel>Motivo de baja</InputLabel>
                                            <Select
                                                // value={ }
                                                label="Motivo"
                                                name='homeType'
                                            // onChange={({ target }) => handleChange('homeType', target.value)}
                                            >
                                                {/* <MenuItem value={''}>Tipo de vivienda</MenuItem> */}
                                                <MenuItem value={'0'}>Motivo 1</MenuItem>
                                                <MenuItem value={'1'}>Motivo 2</MenuItem>
                                            </Select>
                                            {/* {error.homeType && <FormHelperText>Tipo de vivienda requerido</FormHelperText>} */}
                                            <FormHelperText>Motivo de baja</FormHelperText>
                                        </FormControl>
                                        <Box sx={{ '& > :not(style)': { m: 1, width: '30ch' } }} noValidate autoComplete="off">
                                            <TextField
                                                // error={error.address || error.registeredAddress}
                                                // value={homeData.address}
                                                label="Observaciones"
                                                name='address'
                                                // onKeyDown={handleKeyDown2}
                                                // onChange={({ target }) => {
                                                //     let updatedValue = target.value;
                                                //     updatedValue = updatedValue.slice(0, 50); // Limitar a 50 caracteres
                                                //     updatedValue = updatedValue.replace(/[^\w\sñÑáéíóúÁÉÍÓÚ]/g, '')
                                                //     // updatedValue = updatedValue.replace(/[^a-zA-Z0-9ñÑ\s]/g, '');
                                                //     handleChange('address', updatedValue);
                                                // }}
                                                //helperText={error.address ? 'Domicilio a asegurar es requerido' : error.registeredAddress ? 'Domicilio no disponible. Ingrese otro' : ''}
                                                helperText={'Observaciones'}
                                            />
                                        </Box>
                                        <Box display={'flex'} justifyContent={'flex-end'} alignItems={'center'} marginTop={'5vh'}>
                                            <Button
                                                style={{ borderRadius: 20, textTransform: "capitalize" }}
                                                // size="medium"
                                                // color={CODEMP_MUSIMUNDO.includes(codemp) ? "secondary" : "blue"}
                                                variant="outlined"
                                                sx={{ marginLeft: 10 }}
                                            // type="submit"
                                            // onClick={handleCloseModalIsOpen}
                                            >
                                                Atrás
                                            </Button>
                                            <Button
                                                style={{ borderRadius: 20, textTransform: "capitalize" }}
                                                // size="medium"
                                                // color={CODEMP_MUSIMUNDO.includes(codemp) ? "secondary" : "blue"}
                                                variant="contained"
                                                sx={{ marginLeft: 1 }}
                                                type="submit"
                                            >
                                                Dar de baja
                                            </Button>
                                        </Box>
                                    </Form>
                                </form>
                            )}
                        </Formik>
                    </Box>
                </div >
            </Grid >
        </Grid >
    )
};


export default Bajas;
